import React from 'react'
import {StackedColumnChartReportProps} from './StackedColumnChartReport.props'
import './StackedColumnChartReport.styles.css';
import ReactApexChart from "react-apexcharts";
import {NoDataCard} from "../NoDataCard";
import Box from "@mui/material/Box";

export const StackedColumnChartReport: React.FC<StackedColumnChartReportProps> = ({
  data,
  chartOptions = {},
  layoutHeight = "240px",
  layoutWidth = "100%"
}) => {
  const series:any = data?.["data_list"] ? data["data_list"] : [{name: '', data: []}]
  let hasData = false
  for (const item of series) {
    for (const sub_item of item.data) {
      if(hasData) { break; }
      if(sub_item > 0){
        hasData = true;
        break;
      }
    }
  }

  return (
    <Box className={'stacked-column-chart-report'}>
      {/*//@ts-ignores*/
      hasData ? <ReactApexChart
        type="bar"
        // @ts-ignores
        options={chartOptions}
        series={series}
        height={layoutHeight}
        width={layoutWidth}
      /> :
      <NoDataCard type={'stackedColumn'} height={'327px'} padding={'70px 0 0 0'} ></NoDataCard>}
    </Box>
  );
}
